__turbopack_context__.v({
  "chosenEvaluation": "QYDAlW_chosenEvaluation",
  "details": "QYDAlW_details",
  "expanded": "QYDAlW_expanded",
  "impactContext": "QYDAlW_impactContext",
  "impactDetailsDescription": "QYDAlW_impactDetailsDescription",
  "impactDetailsExpandText": "QYDAlW_impactDetailsExpandText",
  "impactOutput": "QYDAlW_impactOutput",
  "overview": "QYDAlW_overview",
  "spacerRow": "QYDAlW_spacerRow",
  "wrapper": "QYDAlW_wrapper",
});
